import axios from 'CanExConfig/axios'

export const createEducation = async (id, data) => {
  const response = await axios(`/api/candidate/v2/candidate_profiles/${id}/educations`, {
    method: 'POST',
    data,
  })

  return response.data.result
}

export const fetchEducations = async id => {
  const response = await axios(`/api/candidate/v2/candidate_profiles/${id}/educations`, {
    method: 'GET',
  })

  return response.data.result
}

export const updateEducation = async (id, data) => {
  const response = await axios(`/api/candidate/v2/educations/${id}`, {
    method: 'PUT',
    data,
  })

  return response.data.result
}

export const deleteEducation = async id => {
  const response = await axios(`/api/candidate/v2/educations/${id}`, {
    method: 'DELETE',
  })

  return response.data.result
}
